export default {
    template: `
        <div>
        <b-form-checkbox-group :name="String(id)" :checked="value" @input="updateValue" stacked>
            <b-form-checkbox v-for="item in options" class="my-3" :value="item.value">{{item['title_'+lang]}}</b-form-checkbox>
        </b-form-checkbox-group>
        </div>
    `,

    // enables v-model compatibility
    model: {
        prop: 'value',
        event: 'input'
    },

    props: {
        id: Number,
        options: Object,
        lang: String,
        value: {
            type: [Array],
            default: () => ([]),
        }
    },

    methods: {
        updateValue(newValue) {
            if (newValue) this.$emit('input', newValue)
        }
    },

};

